import React from "react";
import { withRouter } from "react-router-dom";
import { Button } from "shards-react";
import { EntypoInfo, EntypoClock, EntypoHome } from "react-entypo-icons";
import { strings } from "../localization";
import { ROUTE_PREFIX } from "../config";
import "../components/InactiveTableDialog.css";

function InactiveTableView({ match, history }) {
  // Extract restaurant name from URL params
  const restaurantName = (match && match.params && match.params.restaurantName) || "Restaurant";

  // You can also extract table number from URL params if needed
  const tableNumber = (match && match.params && match.params.tableNumber) || "";

  const handleRefresh = () => {
    // Custom refresh logic can be implemented here
    // For now, we'll just reload the page
    window.location.reload();
  };

  const handleGoToHome = () => {
    // Navigate to home page
    const homePath = `/${ROUTE_PREFIX}${restaurantName}/home`;
    history.push(homePath);
  };

  return (
    <div className="inactive-table-overlay">
      <div className="inactive-table-container">
        <div className="inactive-table-content">
          {/* Header Section */}
          <div className="inactive-table-header">
            <div className="warning-icon-container">
              <EntypoInfo className="warning-icon" />
            </div>
            <h2 className="inactive-table-title">
              {strings.table_inactive_title || "Table Not Available"}
            </h2>
            <p className="inactive-table-subtitle">
              {strings.table_inactive_subtitle || "This table is currently not active or available for ordering."}
            </p>
          </div>

          {/* Content Section */}
          <div className="inactive-table-body">
            <div className="table-info-section">
              <div className="table-details">
                <div className="table-info-item">
                  <span className="table-info-label">Restaurant:</span>
                  <span className="table-info-value">{restaurantName || "Unknown Restaurant"}</span>
                </div>
                {tableNumber && (
                  <div className="table-info-item">
                    <span className="table-info-label">Table:</span>
                    <span className="table-info-value">{tableNumber}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="inactive-table-message">
              <p className="main-message">
                {strings.table_inactive_message || "We're sorry, but this table is currently not accepting orders. This could be due to:"}
              </p>
              <ul className="reasons-list">
                <li>{strings.table_inactive_reason_1 || "The table is temporarily closed"}</li>
                <li>{strings.table_inactive_reason_2 || "Maintenance or cleaning in progress"}</li>
                <li>{strings.table_inactive_reason_3 || "Technical issues with the ordering system"}</li>
                <li>{strings.table_inactive_reason_4 || "The restaurant is currently closed"}</li>
              </ul>
            </div>

            {/* Action Buttons */}
            <div className="inactive-table-actions">
              <Button
                theme="primary"
                size="lg"
                className="refresh-btn"
                onClick={handleRefresh}
              >
                <EntypoClock className="btn-icon" />
                {strings.table_inactive_refresh || "Try Again"}
              </Button>

              <Button
                theme="secondary"
                size="lg"
                className="home-btn"
                onClick={handleGoToHome}
              >
                <EntypoHome className="btn-icon" />
                {strings.table_inactive_home || "Go to Home"}
              </Button>
            </div>

            {/* Additional Help */}
            <div className="help-section">
              <p className="help-text">
                {strings.table_inactive_help || "If the problem persists, please contact restaurant staff for assistance."}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(InactiveTableView);
